const MESH_ID_SEPARATOR = '$'

module.exports = {
    MESH_ID_SEPARATOR
}
